/** @format */

export const REPORT_ORGANIZATION_REQUEST = "REPORT_ORGANIZATION_REQUEST";
export const REPORT_ORGANIZATION_SUCCESS = "REPORT_ORGANIZATION_SUCCESS";
export const REPORT_ORGANIZATION_FAILURE = "REPORT_ORGANIZATION_FAILURE";
